import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import TutorialLauncher from "./TutorialLauncher";
import {
  buildVideoTutorialSteps,
  VIDEO_TUTORIAL_SEEN_KEY,
} from "./videoTutorialConfig";

/**
 * Video page tutorial. Thin wrapper that feeds the shared TutorialLauncher the
 * (localized) video step list and its persistence key.
 */
const VideoTutorial = () => {
  const { t } = useTranslation();
  const steps = useMemo(() => buildVideoTutorialSteps(t), [t]);

  return (
    <TutorialLauncher steps={steps} storageKey={VIDEO_TUTORIAL_SEEN_KEY} />
  );
};

export default VideoTutorial;
